import { UserCompany } from 'shared/types'

export const parseAddress = <
  T extends Pick<
    UserCompany,
    'apartmentNumber' | 'buildingNumber' | 'zipCode' | 'street' | 'city'
  >
>({
  apartmentNumber,
  street,
  buildingNumber,
  city,
  zipCode,
}: T) =>
  `${street} ${buildingNumber}${
    apartmentNumber ? `/${apartmentNumber}` : ''
  }\n${zipCode} ${city}`

export const isAddressCorrect = <
  T extends Pick<UserCompany, 'buildingNumber' | 'zipCode' | 'street' | 'city'>
>({
  street,
  buildingNumber,
  city,
  zipCode,
}: T) => street && buildingNumber && city && zipCode
